export default __webpack_public_path__ + "static/media/buy_health.8bcf7a9f.svg";